import { render, staticRenderFns } from "./CopyrightPracticeDetail.vue?vue&type=template&id=618c8b7e&scoped=true&"
import script from "./CopyrightPracticeDetail.vue?vue&type=script&lang=js&"
export * from "./CopyrightPracticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightPracticeDetail.vue?vue&type=style&index=0&id=618c8b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c8b7e",
  null
  
)

export default component.exports